import api from './api';

export type CustomDomainStatus = 'pending' | 'active' | 'disabled';

export interface EventCustomDomain {
  id: string;
  domain: string;
  targetType?: 'event' | 'landing';
  eventId: string | null;
  parishId: string;
  status: CustomDomainStatus;
  verifiedAt: string | null;
  lastCheckedAt: string | null;
  lastError: string | null;
  createdAt?: string;
  updatedAt?: string;
  dns: {
    type: 'A' | 'CNAME';
    host: string;
    value: string;
    instructions: string;
    alternatives?: Array<{ type: string; value: string }>;
  };
  publicUrl: string | null;
}

export interface HostResolvedEvent {
  targetType?: 'event';
  domain: string;
  eventId: string;
  slug: string;
  title: string;
  status: string;
  coverImage?: string;
  startDate?: string;
  endDate?: string;
  pageTemplate?: string;
  customTheme?: {
    primaryColor?: string;
    secondaryColor?: string;
    fontFamily?: string;
  };
  paths: {
    home: string;
    registration: string;
    legacyHome: string;
    legacyRegistration: string;
  };
}

export type HostResolvedPayload = HostResolvedEvent | import('./parishLandingService').PublicParishLandingPayload;

export async function getEventCustomDomain(eventId: string): Promise<EventCustomDomain | null> {
  const response = await api.get(`/events/${eventId}/custom-domain`);
  return response.data?.data ?? null;
}

export async function saveEventCustomDomain(eventId: string, domain: string): Promise<EventCustomDomain> {
  const response = await api.put(`/events/${eventId}/custom-domain`, { domain });
  return response.data.data;
}

export async function verifyEventCustomDomain(eventId: string): Promise<EventCustomDomain> {
  const response = await api.post(`/events/${eventId}/custom-domain/verify`);
  return response.data.data;
}

export async function disableEventCustomDomain(eventId: string): Promise<EventCustomDomain> {
  const response = await api.delete(`/events/${eventId}/custom-domain`);
  return response.data.data;
}

export async function resolveByHost(host?: string): Promise<HostResolvedPayload | null> {
  try {
    const response = await api.get('/public/by-host', {
      params: host ? { host } : undefined,
    });
    return response.data?.data ?? null;
  } catch {
    return null;
  }
}

/** @deprecated use resolveByHost */
export async function resolveEventByHost(host?: string): Promise<HostResolvedEvent | null> {
  const data = await resolveByHost(host);
  if (!data || (data as any).targetType === 'landing') return null;
  return data as HostResolvedEvent;
}
